import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { TooltipDataType } from "../../../types";

export const useStyles = (props: TooltipDataType, isHovered: boolean) => {
  const { x, y, isLastElementInchart } = props;

  const hasValidPosition =
    typeof x === "number" && typeof y === "number" && x > 0 && y > 0;

  const tooltipWidth = 176;
  const tooltipPadding = 8;

  const left = hasValidPosition
    ? Math.min(
        Math.max(x, tooltipPadding),
        window.innerWidth - tooltipWidth - tooltipPadding
      )
    : -9999;

  const top = hasValidPosition
    ? Math.min(Math.max(y, tooltipPadding), window.innerHeight - tooltipPadding)
    : -9999;

  return {
    customTooltip: {
      position: "fixed",
      top,
      left,
      background: colors.white,
      color: colors.gray900,
      boxShadow: "0px 2px 8px rgba(15, 23, 42, 0.16)",
      borderRadius: "8px",
      padding: "8px",
      width: `${tooltipWidth}px`,
      fontSize: "12px",
      lineHeight: "18px",
      zIndex: 1500,
      pointerEvents: "none"
    },
    labelDot: {
      height: "4px",
      width: "4px",
      borderRadius: "50%",
      border: `2px solid ${colors.blue600}`,
      backgroundColor: isLastElementInchart ? colors.blue600 : colors.white,
      display: "inline-block",
      marginRight: "8px"
    }
  } as CSSObject;
};
